import React from 'react'
import FreeIcon from '@/assets/imgs/freeIcon.png'

import { useGetGiveawayDetail, useGiveawayTracker } from '../hook'
import { useHistory } from 'react-router-dom'
import styles from './index.module.less'
import { useLocation } from 'react-router'
import { GiveawayActivityStatus } from '@/services/api/giveaway/type'

interface FreeActivityIconProps {
  className?: string
}

export const FreeActivityIcon: React.FC<FreeActivityIconProps> = () => {
  const history = useHistory()
  const loaction = useLocation()
  const { trackGiveawayClick } = useGiveawayTracker()

  const inQuestionnairePage = loaction.pathname.includes('/questionnaire/')
  const { status, seq } = useGetGiveawayDetail()

  const toQuestionnairePage = () => {
    trackGiveawayClick()
    history.push(`/questionnaire/${seq}`)
  }

  return status === GiveawayActivityStatus.NotParticipate && !inQuestionnairePage ? (
    <div className={styles.icon}>
      <img src={FreeIcon} onClick={toQuestionnairePage} alt="questionnaire" />
    </div>
  ) : null
}
